module.exports = __webpack_public_path__ + "static/leeland-7ba97ce119f62c8e6e21c36f0c8fe022.png";